module.exports = __webpack_public_path__ + "img/help-icon.b10b7ab4.png";